import { DataSet } from 'libs/end-to-end/src/types/databases/data-sets/data-set';

export const isMergeIntegrationDataSet = (dataSet: DataSet): boolean => {
  const config = dataSet.config;

  return (
    config.dataSetType === 'Integration' &&
    config.integration.integrationType === 'Merge'
  );
};

export const isMergeAtsIntegrationDataSet = (dataSet: DataSet): boolean => {
  const config = dataSet.config;

  return (
    config.dataSetType === 'Integration' &&
    config.integration.integrationType === 'Merge' &&
    config.integration.category === 'ats'
  );
};

export const isMergeAtsIntegrationOrCompositeMergeFilteringDataSet = (
  dataSet: DataSet,
): boolean => {
  return (
    isMergeAtsIntegrationDataSet(dataSet) ||
    (dataSet.config.dataSetType === 'Composite' &&
      dataSet.config.recipe !== null &&
      dataSet.config.recipe.type === 'merge-filtering')
  );
};
